import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { ServiceContractPositionKind } from '../Enums/ServiceContractPositionKind.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputWartungsvertragPosition<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: index */
  index?: number;
  /** Alias: wartungsvertragCode */
  serviceContractId?: number;
  /** Alias: kurztext */
  shortText?: string;
  /** Alias: langtext */
  longtext?: string;
  /** Alias: positionsNummer */
  number?: number;
  /** Alias: bemerkung */
  comment?: string;
  /** Alias: artikelCode */
  articleId?: number;
  /** Alias: anzahl */
  amount?: number;
  /** Alias: anzahlDezimal */
  amountDecimal?: number;
  /** Alias: preis */
  price?: number;
  /** Alias: preis2 */
  price2?: number;
  /** Alias: preis2AbDatum */
  price2StartDate?: string;
  /** Alias: gueltigAb */
  validFrom?: string;
  /** Alias: gueltigBis */
  validUntilDate?: string;
  /** Alias: artikelNummer */
  articleNumber?: string;
  /** Alias: datum */
  date?: string;
  /** Alias: wartungspreisJahr */
  servicePricePerYear?: number;
  /** Alias: prozent */
  percent?: number;
  /** Alias: art */
  positionKind?: ServiceContractPositionKind;
  /** Alias: rabatt */
  discount?: number;
  /** Alias: rabatt2 */
  discount2?: number;
  /** Alias: herstellernummer */
  manufacturerNumber?: string;
  /** Alias: ekPreis */
  purchasePrice?: number;
  /** Alias: lieferantenCode */
  supplierId?: number;
  /** Alias: ekPreis2 */
  purchasePrice2?: number;
  /** Alias: frei1 */
  free1?: string;
  /** Alias: frei2 */
  free2?: string;
  /** Alias: frei3 */
  free3?: string;
  /** Alias: frei4 */
  free4?: string;
  /** Alias: frei5 */
  free5?: string;
  /** Alias: lieferantenText */
  supplierText?: string;
  /** Alias: anzahlLieferant */
  amountSupplier?: number;
  /** Alias: kostenstelle */
  costCenterId?: number;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputWartungsvertragPosition> = {
  index: {
    alias: 'index',
  },
  serviceContractId: {
    alias: 'wartungsvertragCode',
  },
  shortText: {
    alias: 'kurztext',
  },
  longtext: {
    alias: 'langtext',
  },
  number: {
    alias: 'positionsNummer',
  },
  comment: {
    alias: 'bemerkung',
  },
  articleId: {
    alias: 'artikelCode',
  },
  amount: {
    alias: 'anzahl',
  },
  amountDecimal: {
    alias: 'anzahlDezimal',
  },
  price: {
    alias: 'preis',
  },
  price2: {
    alias: 'preis2',
  },
  price2StartDate: {
    alias: 'preis2AbDatum',
  },
  validFrom: {
    alias: 'gueltigAb',
  },
  validUntilDate: {
    alias: 'gueltigBis',
  },
  articleNumber: {
    alias: 'artikelNummer',
  },
  date: {
    alias: 'datum',
  },
  servicePricePerYear: {
    alias: 'wartungspreisJahr',
  },
  percent: {
    alias: 'prozent',
  },
  positionKind: {
    alias: 'art',
  },
  discount: {
    alias: 'rabatt',
  },
  discount2: {
    alias: 'rabatt2',
  },
  manufacturerNumber: {
    alias: 'herstellernummer',
  },
  purchasePrice: {
    alias: 'ekPreis',
  },
  supplierId: {
    alias: 'lieferantenCode',
  },
  purchasePrice2: {
    alias: 'ekPreis2',
  },
  free1: {
    alias: 'frei1',
  },
  free2: {
    alias: 'frei2',
  },
  free3: {
    alias: 'frei3',
  },
  free4: {
    alias: 'frei4',
  },
  free5: {
    alias: 'frei5',
  },
  supplierText: {
    alias: 'lieferantenText',
  },
  amountSupplier: {
    alias: 'anzahlLieferant',
  },
  costCenterId: {
    alias: 'kostenstelle',
  },
  updateTime: {
    alias: 'updateTime',
  },
  insertTime: {
    alias: 'insertTime',
  },
  customFields: {
    alias: 'customFields',
    entity: Entities.customField,
  },
  id: {
    alias: 'code',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputWartungsvertragPositionEntityDefinition: EntitiyDefinition<InputWartungsvertragPosition> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputWartungsvertragPosition',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
